import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import VideoBg from "../../assets/bg-Home.mp4";
import NavbarV2 from "../../components/Navbar/NavbarV2";
import "./HomePage.css";
import WhatIsDrinq from "../../components/WhatIsDrinq/WhatIsDrinq";
import DRINQBenefits from "../../components/DRINQBenefits/DRINQBenefits";
import MyLocations from "../../components/MyLocations/MyLocations";
import OurClients from "../../components/OurClients/OurClients";
import HomeContact from "../../components/HomeContact/HomeContact";
import Footer from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";
import { getLangUrls } from "../../utils/languageRouting";
export default function HomePage() {
  const { t } = useTranslation();
  const location = useLocation();
  const seo = getLangUrls("/", location.pathname);
  return (
    <>
      <Helmet>
        <html lang={seo.lang} />
        <title>{t("seo.home.title")}</title>
        <meta name="description" content={t("seo.home.description")} />
        <link rel="canonical" href={seo.canonical} />
        <link rel="alternate" hrefLang="fr" href={seo.hreflangFr} />
        <link rel="alternate" hrefLang="en" href={seo.hreflangEn} />
        <link rel="alternate" hrefLang="x-default" href={seo.hreflangFr} />
      </Helmet>

      {/* HERO SECTION */}
      <div className="home-container">
        <video
          src={VideoBg}
          autoPlay
          loop
          muted
          playsInline
          className="home-video"
        />

        <div className="home-overlay"></div>

        <div className="home-content">
          <NavbarV2 />

          <div className="home-center">
            <h1 className="home-title">{t("homePage.hero.title")}</h1>
            <p className="home-tagline">{t("homePage.hero.tagline")}</p>
          </div>
        </div>
      </div>

      {/* REST OF THE PAGE (OUTSIDE CONTAINER!) */}
      <WhatIsDrinq />
      <DRINQBenefits />
      <div id="locations">
        <MyLocations />
      </div>
      <OurClients />
      <HomeContact />
      <Footer />
    </>
  );
}
